import { render, staticRenderFns } from "./TripAnnouncements.vue?vue&type=template&id=43a477ba&scoped=true&"
import script from "./TripAnnouncements.vue?vue&type=script&lang=js&"
export * from "./TripAnnouncements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a477ba",
  null
  
)

export default component.exports